module.exports = __webpack_public_path__ + "img/187w.16012d6.jpg";